export { removeAllListeners, removeListener, listen, emit, onError, triggerError };
var listeners = {};
var errorCbs = [];
function removeAllListeners() {
  listeners = {};
  errorCbs = [];
}
function removeListener(event, cb) {
  if (!listeners[event]) {
    return;
  }
  var index = listeners[event].indexOf(cb);
  if (index === -1) {
    return;
  }
  listeners[event].splice(index, 1);
}
function listen(event, cb) {
  var once = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!listeners[event]) {
    listeners[event] = [];
  }
  if (once) {
    listeners[event].push(function runOnce(payload, actionDetail) {
      removeListener(event, runOnce);
      cb(payload, actionDetail);
    });
  } else {
    listeners[event].push(cb);
  }
}
function onError(cb) {
  errorCbs.push(cb);
}

// Note!: we can't define a better type than 'unknown' here since all the types are defined in package one-auth
// and sdk is consumed by one-auth, so it will do a cyclic dependencies
// should be refactored and moves the types into sdk package
function emit(event, payload, actionDetail) {
  if (!listeners[event]) {
    return;
  }
  listeners[event].forEach(function (cb) {
    cb(payload, actionDetail);
  });
}
function triggerError(scope, error) {
  var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  errorCbs.forEach(function (cb) {
    cb({
      scope: scope,
      error: error,
      payload: payload
    });
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/one-auth-sdk/dist/esm/utils/eventManager.js
// module id = 147
// module chunks = 11